export interface TransmissionStateGroup {
  transmissionStatusId: TransmissionState;
  quantityVehicle: number;
}

export enum TransmissionState {
  MOVING = 1, // Vehículo en movimiento
  STOPPED_IGNITION_ON = 2, // Detenido con ignición encendida
  STOPPED_IGNITION_OFF = 3, // Detenido con ignición apagada
  TRANSMISSION_OFF = 4, // Transmisión apagada
  NO_COVERAGE = 5, // Sin cobertura (GPS o red)
  GPS_ERROR = 6, // Error de GPS
  UNKNOWN = 0, // Estado desconocido
}
